import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  padding: 0 5px 20px 0;
`;

export default Container;
